import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.889 0C3.444 0 3 .444 3 .889v4.444c0 .89.889.89.889 1.778v8c0 .445.444.889.889.889h.889c.444 0 .889-.444.889-.889v-8c0-.889.888-.889.888-1.778V.89C7.444.444 7 0 6.556 0c-.223 0-.223.271-.223.444V4c0 .173 0 .444-.222.444S5.89 4.174 5.89 4V.444c0-.173 0-.444-.222-.444h-.889c-.222 0-.222.271-.222.444V4c0 .173 0 .444-.223.444-.222 0-.222-.27-.222-.444V.444c0-.173 0-.444-.222-.444Zm8.889 0c-.89 0-2.55.209-3.111 1.333-.445.89-.445 3.111-.445 4V8.89c0 .444.445.889.89.889v5.333c0 .445.444.889.888.889h.889c.444 0 .889-.444.889-.889V0Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructureRestaurant16 = createIcon(IconComponent);